<template>
    <div class="pageWrap flexCol">
        <div class="flexBox">
            <task-detail :detail="detail"></task-detail>
        <van-popup v-model="videoPreviewShow" :round="false">
            <div class="prevideoBox">
                <video :src="previewVideoUrl" controls="controls" autoplay="auto" width="100%" height="100%"></video>
            </div>
        </van-popup>
        <div class="taskBox" v-for="(item,index) in stuTaskList" :key="index">
            <div class="moreBox icon-more" @click="clickMore(item)" v-if="item.isSelf == 1"></div>
            <div class="stuInfoBox rowAc">
                <van-image
                    round
                    width="0.4rem"
                    height="0.4rem"
                    fit="cover"
                    :src="getHeadImg(item.headUrl,item.sex)"
                />
                <div class="stuRightBox">
                    <div class="stuName">{{item.studentName}}</div>
                    <div class="flexRow"><div class="time">{{item.submitTime}}</div><div class="submit">提交</div></div>
                </div>
            </div>
            <div class="taskContentBox">
                <div class="taskContent">
                    {{item.homeworkData.content}}
                </div>
                <div class="fileBox">
                    <div class="fileItemBox" v-for="(videoItem,videoIndex) in item.homeworkData.videoList" :key="'video'+videoIndex">
                        <video  class="videoStyle" :poster="videoItem+'?x-oss-process=video/snapshot,t_50,f_jpg,ar_auto'" preload="auto" controls="controls">
                            <source :src="videoItem" type="video/mp4">
                            <source :src="videoItem" type="video/ogg">
                            <source :src="videoItem" type="video/webm">
                        </video>
                    </div>
                    <div class="fileItemBox" @click="clickImgView(imgItem)" v-for="(imgItem,imgIndex) in item.homeworkData.imgList" :key="'img'+imgIndex">
                        <img :src="imgItem" alt="" class="imgStyle">
                    </div>
                    <div class="fileItemBox rowJcAc voiceItem" v-for="(voiceItem,voiceIndex) in item.homeworkData.voiceList" :key="'voice'+voiceIndex" @click="playVoice(voiceItem)">
                        <!-- <audio :src="voiceItem" class="videoStyle" controls="controls"></audio> -->
                        <img src="../../assets/static/task/music.png" alt="" class="musicImg">
                        <div class="voiceText">音频文件</div>
                    </div>
                    
                </div>
            </div>
            <!-- <div class='rowAc rowJe handleBox'>
                <div class="icon icon-heart"></div>
                <div class="text">赞</div>
                <div class="icon icon-message"></div>
                <div class="text">评论</div>
                <div class="icon icon-share"></div>
                <div class="text">分享</div>
            </div> -->
            <div class="commentBox" v-if="item.teacherName">
                <div class="likeList rowAc">
                    <div class="rowJbAc likeItem">
                        <!-- <div class="icon-like icon"></div> -->
                        <div class="name">{{item.teacherName}}</div>
                        <div class="time">{{item.evaTime}}</div>
                    </div>
                </div>
                <div class="fileBox1">
                    <!-- 文字 -->
                    <div class="taskContent1">
                    {{item.evaluationData.content}}
                    </div>
                    <div class="fileContent flexRow">
                        <!-- 视频 -->
                    <div v-for="(item1,index1) in item.evaluationData.videoList" :key="'video'+index1" class="fileItem" @click="previewVideo(item1)">
                        <video  loop="loop" width="100%" preload="auto" :src="item1">
                            <!-- <source :src="item1" type="video/ogg" />
                            <source :src="item1" type="video/mp4" /> -->
                        </video>
                        <img src="../../assets/static/task/play-circle.png" class="playCircle" alt="">
                    </div>
                    <!-- 图片 -->
                    <div v-for="(item2,index2) in item.evaluationData.imgList" :key="'img'+index2" class="fileItem" @click="clickImgView(item2)">
                        <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="item2"
                        />
                    </div>
                    <!-- 音频 -->
                    <div  v-for="(item3,index3) in item.evaluationData.voiceList" :key="'voice'+index3" class="fileItem rowJcAc voiceItem1" @click="playVoice(item3)">
                        <img src="../../assets/static/task/musicIcon.svg" alt="" class="musicIcon">
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div class="bottomBtnBox flexRow">
            <div class="bottomBtn" @click="againSubmit">再次提交</div>
        </div>
        <!-- 更多弹框 -->
        <van-popup v-model="popupShow" position="bottom">
            <div class="popupWrap">
                <div class="" @click="alterTask">修改作业内容</div>
                <div class="del" @click="clickDel">删除</div>
                <div class="cancel" @click="clickCancel">取消</div>
            </div>
        </van-popup>
        <!-- 图片预览弹框 -->
        <van-image-preview v-model="imgPreviewShow" :images="images" :showIndex="false"></van-image-preview>
    </div>
</template>
<script>
import taskDetail from '../../components/task/taskDetail.vue'
import {getTaskDetailAPI,putDetailAPI} from '../../utils/api/taskApi'
export default {
    name: 'taskDetailPage',
    components: { taskDetail },
    data() {
        return {
            popupShow: false,
            imgPreviewShow: false,
            images: [],
            taskId: '',
            detail: {},
            stuTaskId: '', // 学生作业id,用来判断是否是自己的
            stuTaskList: [],
            clickItem: {} , // 记录当前点击item， // 删除、修改时用
            isCreated: false,

            videoPreviewShow: false, // 预览视频是否展示
            previewVideoUrl: '', // 预览视频路劲
            parentUid: ''
        }
    },
    created() {
        this.isCreated = true
        this.$bus.$emit('pageEvent',{pageName: 'taskDetailPage',type: 'add'})
        this.taskId = this.$route.params.taskInfo.homeworkId
        console.log('created',this.taskId)
        this.stuTaskId = this.$route.params.taskInfo.id
        this.detail = this.$route.params.taskInfo
        this.parentUid = this.$route.params.parentUid
        this.getDetail(this.taskId)
    },
    beforeRouteEnter(to,from,next) {
        next(vm => {
            if(from.path == '/submitTask') { // 若从修改作业页面进来，悬浮弹框关闭
                vm.popupShow = false
            }
        })
    },
    beforeRouteLeave(to,from,next) {
        if(to.path == '/submitTask' || to.path == '/voice') {
            this.$bus.$emit('pageEvent',{pageName: 'taskDetailPage',type: 'add'})
        }else {
            this.$bus.$emit('pageEvent',{pageName: 'taskDetailPage',type: 'del'})
        }
        next()
    },
    activated() {
        console.log('actived-----------')
        if(!this.isCreated) {
            this.getDetail(this.taskId)
        }
    },
    deactivated() {
        this.isCreated = false;
    },
    methods: {
        // 预览视频
        previewVideo(item) {
            this.previewVideoUrl = item
            this.videoPreviewShow = true
        },
        // 点击播放音频
        playVoice(item) {
            this.$router.push({name: 'Voice', params: {url: item}})
        },
        // 点击更多
        clickMore(item) {
            console.log("id",item.id)
            this.clickItem = item
            this.popupShow = true
        },
        // 点击取消
        clickCancel() {
            this.popupShow = false
        },
        // 点击图片预览
        clickImgView(url) {
            this.images = [url]
            this.imgPreviewShow = true
        },
        // 点击修改作业
        alterTask() {
            this.$router.push({name: 'SubmitTask',params:{taskInfo: this.detail,alterData: this.clickItem}})
        },
        // 点击再次提交作业
        againSubmit(){
            this.$router.push({name: 'SubmitTask',params:{taskInfo: this.detail,workType: 4}})
        },
        // 获取详情
        getDetail(id) {
            getTaskDetailAPI({homeworkId: id,parentUid:this.parentUid}).then(res => {
                console.log('作业详情：',res)
                if(res.resultCode == 200) {
                    this.stuTaskList = JSON.parse(JSON.stringify(res.data))
                    this.stuTaskList.forEach(item => {
                        item.evaluationData['imgList'] = []
                        item.evaluationData['videoList'] = []
                        item.evaluationData['voiceList'] = []
                        if(item.evaluationData.imageUrl) {
                            item.evaluationData['imgList'] = item.evaluationData.imageUrl.split(',')
                        }
                        if(item.evaluationData.videoUrl) {
                            item.evaluationData['videoList'] = item.evaluationData.videoUrl.split(',')
                        }
                        if(item.evaluationData.voiceUrl) {
                            item.evaluationData['voiceList'] = item.evaluationData.voiceUrl.split(',')
                        }
                        item.homeworkData['imgList'] = []
                        item.homeworkData['videoList'] = []
                        item.homeworkData['voiceList'] = []
                        if(item.homeworkData.imageUrl) {
                            item.homeworkData['imgList'] = item.homeworkData.imageUrl.split(',')
                        }
                        if(item.homeworkData.videoUrl) {
                            item.homeworkData['videoList'] = item.homeworkData.videoUrl.split(',')
                        }
                        if(item.homeworkData.voiceUrl) {
                            item.homeworkData['voiceList'] = item.homeworkData.voiceUrl.split(',')
                        }
                    })
                }
            })
        },
        getHeadImg(url,sex) {
            if(url) {
                return url
            }else {
                return sex == 1 ? require('../../assets/static/public/boy.png') : require('../../assets/static/public/girl.png')
            }
        },
        // 点击删除
        clickDel() {
            var obj = {
                id: this.clickItem.id,
                workType: 2
            }
           putDetailAPI(obj).then(res => {
               console.log('删除返回值：',res)
               if(res.resultCode == 200) {
                   this.$toast('删除成功')
                   this.getDetail(this.taskId)
                   this.popupShow = false
               }else {
                   this.$toast(res.resultStr)
               }
           }) 
        }
    }
}
</script>
<style lang="scss" scoped>
.pageWrap {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
    // padding: .12rem;
    // box-sizing: border-box;
    background: linear-gradient(180deg, #89C4FF 0%, #F5F6F9 20%);
}
.voiceItem {
    width: 1.4rem !important;
    height: .52rem;
    background: #F0F5FF;
}
.musicImg {
    width: .32rem;
    height: .32rem;
}
.voiceText {
    color: #5A6073;
    font-size: .14rem;
    margin-left: .12rem;
}
.taskBox {
    position: relative;
    border-radius:  .12rem;
    background: #ffffff;
    padding: 0 .16rem .4rem;
    margin-top: .12rem;
    box-sizing: border-box;
    overflow: hidden;
}
.moreBox {
    position: absolute;
    top: .1rem;
    right: .15rem;
    font-size: .2rem;
    color: #9EA5BB;
}
.stuInfoBox {
    margin-top: .12rem;
}
.stuRightBox {
    margin-left: .1rem;
    font-size: .12rem;
    line-height: .18rem;
    .stuName {
        color: #333843;
        font-size: .16rem;
        line-height: .24rem;
    }
    .time {
        color: #5A6073;
    }
    .submit {
         color: #9EA5BB;
         margin-left: .04rem;
    }
}
.taskContentBox {
    margin-top: .12rem;
    font-size: .14rem;
    line-height: .21rem;
    color: #5A6073;
}
// .fileBox {
//     margin-top: .12rem;
// }
.fileItemBox {
    margin-top: .12rem;
    width: 100%;
    border-radius: .08rem;
    overflow: hidden;
}
.videoStyle,.imgStyle {
    width: 100%;
    border-radius: .08rem;
}
.handleBox {
    margin-top: .17rem;
    .icon {
        font-size: .2rem;
        margin-left: .16rem;
        color: #5A6073;
    }
    .text {
        font-size: .14rem;
        line-height: .2rem;
        color: #333843;
        font-weight: 500;
        margin-left: .04rem;
    }
}
.commentBox {
    background: #F8FAFD;
    border-radius: .06rem;
    // padding-left: .14rem;
    // padding-right: .14rem;
    margin-top: .17rem;
    box-sizing: border-box;
    .likeList {
        width: calc(100%);
        padding: .11rem .14rem;
        box-sizing: border-box;
        border-bottom: 1px solid #E8EBF3;
        flex-wrap: wrap;
        .likeItem {
            // margin-right: .1rem;
            width: 100%;
        }
        .icon {
            color: #FF4D4F;
            margin-right: .04rem;
        }
        .name {
            font-size: .14rem;
            line-height: .20rem;
            color: #576B95;
        }
        .time{
            font-size: .14rem;
            line-height: .20rem;
            color: #A6AAB8;
        }
    }
    .fileBox1 {
        padding: .08rem 0 .12rem;
        box-sizing: border-box;
        .taskContent1 {
            font-size: .14rem;
            line-height: .21rem;
            color: #5A6073;
            padding:0 .14rem;
            box-sizing: border-box;
        }
        .fileContent{
            flex-wrap: wrap;
            padding: 0 0 0 .08rem;
            .fileItem {
                position: relative;
                width: .93rem;
                height: .93rem;
                border-radius: .08rem;
                overflow: hidden;
                position: relative;
                margin-left: .06rem;
                margin-top: .08rem;
                box-sizing: border-box;
            }
            .voiceItem1 {
                background: #36CFC9;
            }
            .musicIcon {
                width: .26rem;
                height: .26rem;
            }
            .playCircle {
                width: .32rem;
                height: .32rem;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-top: -.16rem;
                margin-left: -.16rem;
            }
        }
    }
}
/deep/ .van-popup {
    border-top-left-radius: .16rem;
    border-top-right-radius: .16rem;
}
.popupWrap {
    border-top-left-radius: .16rem;
    border-top-right-radius: .16rem;
    line-height: .56rem;
    font-size: .17rem;
    >div {
        text-align: center;
    }
    .del {
        color: #FA5151;
        border-top: 1px solid rgba(0,0,0,0.1);
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
    .cancel {
        border-top: .08rem solid #F2F2F2;
    }
}
.prevideoBox {
    width: 100%;
    height: 100%;
}
.bottomBtnBox{
    padding: 0.08rem .16rem;
    box-sizing: border-box;
    min-height: .64rem;
    background: #ffffff;
    width: 100%;
}
.bottomBtn {
    // width: calc(100% - .32rem);
    width: 100%;
    height: .48rem;
    border-radius: .06rem;
    line-height: .48rem;
    text-align: center;
    font-size: .16rem;
    background: #1A7AF8;
    color: #FFFFFF;
}
.flexBox{
    flex: 1;
    overflow: auto;
    padding: .12rem;
    box-sizing: border-box;
}
</style>